import { SiteSettings } from "../../models/shared/SiteSettings";
import { NavigationItem } from "./NavigationItem";
import { NavigationSection } from "./NavigationSection";

export const createNavigation = (siteSettings: SiteSettings) =>
  siteSettings.mainNavigation?.map<NavigationSection>(mainNavItem => ({
    title: mainNavItem.title,
    color: mainNavItem.color,
    items: mainNavItem.firstLevelItems?.map(item => {
      const firstLevelItem: NavigationItem = {
        title: item.title,
        items: item.subitems?.map(subitem => {
          const subitemLink: NavigationItem = {
            title: subitem.title,
            description: subitem.description,
            isExternal: subitem.isExternal,
            linkReference: subitem.link,
            externalLink: subitem.externalLink,
            anchor: subitem.anchor
          };

          return subitemLink;
        })
      };

      return firstLevelItem;
    })
  })) ?? [];
